import React from 'react';

const ArrowIcon = ({ onClickArrow, iconClassnames }: { onClickArrow: () => void; iconClassnames: string }) => {
    return <p className={`ms-subscribe__details__form__icon-container__button__${iconClassnames}`} onClick={onClickArrow}></p>;
};

export { ArrowIcon };
